export const DASHBOARD_URLS = {
  dashboard: `/dashboard/my-dashboard`,
  teamMembers: `/dashboard/team-members`,
  createTeamMember: `/dashboard/team-members/create-members`,
  editMember: `/dashboard/team-members/edit-member`
};
export const COUNTRY_CODE = 'countryCode';
export const COUNTRY_FLAG_URL = `${process.env.NEXT_PUBLIC_STATIC_URL}/images/country/#{${COUNTRY_CODE}}.svg`;

export const DATAFLOW_LOGO_URL = `${process.env.NEXT_PUBLIC_STATIC_URL}/images/dataFlowLogo.png`;

export const SEARCH_PARAMS_KEYS = {
  activeClaimItemId: 'activeClaimItemId',
  verifierEmail: 'verifierEmail',
  caseId: 'caseId',
  token: 'token',
  code: 'code'
};

export const PAGE_URLS = {
  verifyBulkDetails:
    '/home/verify-details?token=#{token}&emailChanged=#{emailChanged}&verifierEmail=#{verifierEmail}&activeClaimItemId=#{activeClaimItemId}&claimItemId=#{claimItemId}&verifierId=#{verifierId}&cvcrId=#{cvcrId}',
  emailOtp:
    '/authentication/email-otp?token=#{token}&verifierEmail=#{verifierEmail}',
  email: '/authentication/email?token=#{token}',
  loginOtp: '/onboarding/login-otp?verifierEmail=#{verifierEmail}',
  login: '/onboarding/login',
  PendingRequests: '/home/pending-requests',
  CompletedRequests: '/home/completed-requests',
  selectAccount: '/onboarding/select-account?userId=#{userId}&token=#{token}'
};

export const NON_LOGGED_IN_PAGE_URLS = [PAGE_URLS.email, PAGE_URLS.login];

export const VALID_PAGE_URLS = [
  PAGE_URLS.email,
  PAGE_URLS.login,
  PAGE_URLS.emailOtp?.split('?')?.[0],
  PAGE_URLS.loginOtp,
  PAGE_URLS.CompletedRequests,
  PAGE_URLS.PendingRequests,
  PAGE_URLS.selectAccount?.split('?')?.[0],
  PAGE_URLS.verifyBulkDetails?.split('?')?.[0]
];

export const VALID_FILE_TYPES = ['PNG', 'JPG', 'PDF'];

export const EMPTY_SCREEN_IMAGE_URL = `${process.env.NEXT_PUBLIC_STATIC_URL}/images/no_documents.png`;
export const EMAIL_URL = '/authentication/email';
